import { API_ENDPOINT, X_AUTH_TOKEN, BUCKET_NAME } from "./constants";

export const pushS3 = (data) => {
  const body = JSON.stringify({
    file_content: data.content,
    file_name: data.path,
    bucket_name: BUCKET_NAME,
  });

  fetch(`${API_ENDPOINT}push-s3`, {
    method: "POST",
    headers: { 
      "Content-Type": "text/plain",
      authorizationToken: X_AUTH_TOKEN,
    },
    body: body
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      if (data["statusCode"] != 200) {
        console.log("error when uploading");
      }
    })
    .catch((error) => {
      console.error("There was a problem with the fetch operation:", error);
    });
};

// Decode a data-URL screenshot without going through fetch(): telemetry
// instruments every fetch and records its URL, so fetch(dataUrl) would ship
// the whole base64 photo to HyperDX as a span attribute.
const dataUrlToBlob = (dataUrl) => {
  const [header, base64] = dataUrl.split(',');
  const mime = (header.match(/^data:(.*?);base64$/) || [])[1] || 'image/png';
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return new Blob([bytes], { type: mime });
};

export const putS3 = async (type, data) => {
  if (!data) {
    console.log("no data to put in S3")
  }

  const url = localStorage.getItem(`${type}_put_url`)
  if (url) {
    try {
      const blob = dataUrlToBlob(data);
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': blob.type,
        },
        body: blob,
      });

      if (response.ok) {
        return true;
      } else {
        console.log('Error', response);
        return false;
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      return false
    }
  } else {
    console.log('no url found')
    return false;
  }
}

export const triggerMeasurement = async (mid) => { 
  try {
    if (mid) {
      const success = await fetch(`${API_ENDPOINT}scan-trigger-measurements`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          measure_id: mid
        })
      })
        .then((res) => {
          // Gateway errors (e.g. a 500 from Google Frontend) return JSON bodies
          // with neither `error` nor `statusCode`, which isMeasurementSuccess
          // would otherwise classify as a successful trigger.
          if (!res.ok) {
            console.log('Error: triggerMeasurement - HTTP', res.status);
            return false;
          }
          return res.json();
        })
        .catch((e) => {
          console.log('Error: triggerMeasurement - ', e);
          return false;
        });
      return success;
    } else {
      return false;
    }
  } catch (error) {
    console.error('Error with triggerMeasurement:', error);
    return false
  }
}

export const scanPushAnswers = async (mid, answers) => {
  if (mid) {
    const success = await fetch(`${API_ENDPOINT}scan-push-answers`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        measure_id: mid,
        answers: answers
      })
    })
      .then((res) => res.json())
      .then((res) => res)
      .catch((e) => {
        console.log('Error: scanPushAnswers - ', e);
        return false;
      });
    // Presigned URLs carry auth signatures: log presence only (console is captured by telemetry)
    console.log('scanPushAnswers completed', {
      hasFront: !!success?.front_put_url,
      hasSide: !!success?.side_put_url,
    })
    return success;
  } else {
      return false;
  }
};